export default __webpack_public_path__ + "static/media/arrows-idle.1737ec0b.svg";